const DEFAULT_CODE_LENGTH = 4;

export const getCodeString = (code: number, length = DEFAULT_CODE_LENGTH) =>
    code.toString().padStart(length, "0");
